import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React from 'react';
import useStyles from './billDetailsStyles';

/** Confirmation step for the two irreversible-looking card actions (Figma: push / approve dialogs). */
export function ConfirmActionModal(_ref) {
  let confirmLabel = _ref.confirmLabel,
    isOpen = _ref.isOpen,
    message = _ref.message,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    title = _ref.title;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: onClose,
    isOpen: isOpen,
    leftButton: /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "text"
    }, "Close"),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      onClick: onConfirm,
      size: "small",
      variant: "contained"
    }, confirmLabel),
    title: title
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.confirmText
  }, message));
}